export default __webpack_public_path__ + "static/media/eight_of_pentacles.748f6ae4.png";